import React from 'react'
import { connect } from 'react-redux'
import MenuButton from './MenuButton'
import Ink from 'react-ink'
import PropTypes from 'prop-types'

let menupage = 0;

class Menu extends React.Component {
  constructor(props) {
    super(props)
    this.handleTouchTapRight = this.handleTouchTapRight.bind(this);
    this.handleTouchTapLeft = this.handleTouchTapLeft.bind(this);
  }

  handleTouchTapLeft() {
    menupage = menupage > 0 ? menupage - 1 : 0;
    this.setState({ currentPage: menupage });
  }

  handleTouchTapRight() {
    menupage += 1;
    this.setState({ currentPage: menupage });
  }

  render() {
    const items = [];
    for (let i = 0; i < this.props.groups.length; i++) {
      const currentItem = this.props.groups[i];
      
      if (!currentItem.Hidden) {
        items.push({
          id: currentItem.KeyLayoutGroupId,
          text: currentItem.Description,
          sequence: currentItem.Sequence,
          fileAttachmentId: currentItem.FileAttachmentId,
          shouldBlink: currentItem.ShouldBlink,
          opacity: currentItem.Opacity
        });
      }
    }

    let itemsPerPage = 12;
    if (window.matchMedia('(max-width: 768px)').matches) {
      itemsPerPage = 8;
    }

    const fromItem = itemsPerPage * menupage;
    const toItem = itemsPerPage * (menupage + 1);
    const nrOfGroups = this.props.groups.length;

    let buttonLeftHTML = '';
    if (fromItem !== 0 && (fromItem > 0 || toItem <= nrOfGroups)) {
      buttonLeftHTML = (<button className="menubuttonnext" onClick={this.handleTouchTapLeft}>
        <i className='caret left icon' /><Ink />
      </button>);
    }

    let buttonRightHTML = '';
    if (nrOfGroups > toItem) {
      buttonRightHTML = (<button className="menubuttonnext" onClick={this.handleTouchTapRight}>
        <i className='caret right icon' /><Ink />
      </button>);
    }

    return (
      <div id="menubarcontainer">
        <div id="menubar">
          {items.slice(fromItem, toItem).map(text => <MenuButton key={text.id} text={text.text} id={text.id} fileAttachmentId={text.fileAttachmentId} shouldBlink={text.shouldBlink} />)}
        </div>
        {buttonLeftHTML}
        {buttonRightHTML}
      </div>)
  }
}

Menu.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.shape({
    KeyLayoutGroupId: PropTypes.number.isRequired
  })).isRequired
}

function mapStateToProps(state) {
  return {
    groups: state.layoutState.groups.items
  }
}

export default connect(mapStateToProps)(Menu)



// WEBPACK FOOTER //
// src/components/Menu.jsx